/* eslint-disable */
import React, { FC, useEffect, useState } from 'react';
import useUrlState from '@ahooksjs/use-url-state';
import { useHistory } from 'react-router';
import { Spin } from 'antd';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { auth, getToken, getTokenSpec } from '~/api/auth';
import { useMutableCallback } from '~/hooks';
import paths from '~/pages/paths';
import features from '~/constants/features';

export interface AuthProps {
  flowKey: string;
  pathOnSuccess?: string;
}

const AuthCallback: FC<AuthProps> = (props) => {
  const dispatch = useDispatch();
  const { flowKey, pathOnSuccess = paths.home._ } = props;
  const [urlState] = useUrlState<{
    code: string;
    session_state: string;
    utm_source?: string;
    utm_campaign?: string;
    utm_medium?: string;
    utm_term?: string;
    utm_content?: string;
  }>();
  const { code, session_state, utm_source, utm_campaign, utm_medium, utm_term, utm_content } =
    urlState;
  const history = useHistory();
  const [isLoading, setLoading] = useState(false);

  const onSuccess = useMutableCallback(() => {
    history.push(pathOnSuccess);
  });
  const onError = useMutableCallback(() => {
    history.replace(paths.home._);
  });

  if (utm_source || utm_campaign || utm_medium || utm_term || utm_content) {
    localStorage.setItem(
      'utmUrlState',
      JSON.stringify({
        utm_source,
        utm_campaign,
        utm_medium,
        utm_term,
        utm_content,
      })
    );
  }

  console.log('utmUrlState', utm_source, utm_campaign, utm_medium, utm_term, utm_content);

  useEffect(() => {
    void (async () => {
      setLoading(true);
      try {
        auth.clearSession(); // clear session before getting new token
        const { url, clientId, redirectUrl, logoutUrl } = await getTokenSpec(flowKey);
        const redirectUrlParams = Object.fromEntries(new URL(redirectUrl).searchParams.entries());
        if (redirectUrlParams && Object.keys(redirectUrlParams || {})?.length) {
          localStorage.setItem('redirectUrlParams', JSON.stringify(redirectUrlParams));
        }
        console.log('redirectUrlParams', redirectUrlParams);
        const urlParams = Object.fromEntries(new URL(url).searchParams.entries());
        if (urlParams && Object.keys(urlParams || {})?.length) {
          localStorage.setItem('redirectUrlParams', JSON.stringify(redirectUrlParams));
        }
        console.log('urlParams', urlParams);

        localStorage.setItem('urlParams', JSON.stringify(urlParams));
        const isLocalhost = window.location.hostname === 'localhost';
        const urlProp = flowKey === 'agent-signup' || isLocalhost ? url : 'api/v2/auth/token';
        console.log(`Retrieved token spec for flowKey: ${flowKey}`);
        const actualRedirectUri = new URL(window.location.href);
        actualRedirectUri.searchParams.delete('code');
        actualRedirectUri.searchParams.delete('session_state');
        actualRedirectUri.searchParams.delete('iss');
        console.log('111actualRedirectUri', actualRedirectUri.toString());
        const { access_token, refresh_token } = await getToken({
          flowKey,
          url: urlProp,
          data: {
            grant_type: 'authorization_code',
            client_id: clientId,
            redirect_uri: actualRedirectUri.toString(),
            session_state,
            code,
          },
        });

        console.log('redirectUrl', url);
        console.log(`Obtained auth token for flowKey: ${flowKey}`);
        auth.setSession(access_token, refresh_token, clientId, features.realm, logoutUrl);
        onSuccess();
      } catch (error) {
        onError();
      }
      setLoading(false);
    })();
  }, [code, session_state, onSuccess, flowKey, onError]);

  return <Container>{isLoading ? <Spin size="large" /> : null}</Container>;
};

const Container = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
`;

export default AuthCallback;
